import { Module } from 'wrapper6'
import ObjectFitClass from '../utils/_object-fit'

const $ = jQuery

export default class InstagramFeed extends Module {
  ready (app) {
    const TARGET = document.getElementById('mtt-instagram-feed-target')

    if (TARGET) {
      const data = {
        lang: document.documentElement.lang
      }

      jQuery.get(main_theme_objects.rest_url + 'prima/instagram/lazyload', data, (response) => {
        if (response !== 0) {
          TARGET.innerHTML = response.markup
          new ObjectFitClass()
        }
      })
    }
  }
}
